import { render, staticRenderFns } from "./LastSlide.vue?vue&type=template&id=6a05730e&scoped=true&"
import script from "./LastSlide.vue?vue&type=script&lang=js&"
export * from "./LastSlide.vue?vue&type=script&lang=js&"
import style0 from "./LastSlide.vue?vue&type=style&index=0&id=6a05730e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a05730e",
  null
  
)

export default component.exports